module.exports = __webpack_public_path__ + "static/media/DisplayIT-PassedIcon-greyscale.f3f73134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/performances/DisplayIT-PassedIcon-greyscale.png
// module id = 2380
// module chunks = 0